export const renderFrequencyLabel = (frequency) => {
  switch (`${frequency}`) {
    case "0.5":
      return "2 weeks";

    case "1":
      return "1 month";

    case "1.5":
      return "1.5 months";

    case "2":
      return "2 months";

    case "3":
      return "3 months";

    case "4":
      return "4 months";

    case "5":
      return "5 months";

    case "6":
      return "6 months";

    case "12":
      return "12 months";

    default:
      return null;
  }
};
